/* eslint-disable no-console */
<template>
  <b-container>
    <AdvertiserInfo ref="advertiserInfo" :campaign="campaign" :logoUrl="logoUrl" />

    <Tabs class="campaign-tabs" v-if="advertiser">
      <div label="Links prontos ou personalizados" shortLabel="Links" buttonClass="button-links"
        :trackWithLabel="`links prontos ou personalizados_${pageAdvertiser.name}`" class="h-100" v-if="showLinksTab">
        <LinkFormCard v-if="pageAdvertiser" :usePageAdvertiser="true" @showAllRules="showAdvertiserInfoRules()" />
      </div>
      <div label="Banner estático ou banner rotativo" shortLabel="Banners" buttonClass="button-banners"
        :trackWithLabel="`banner estático ou banner rotativo_${pageAdvertiser.name}`" class="h-100" v-if="showBannersTab">
        <BannerFormCard @showAllRules="showAdvertiserInfoRules()" />
      </div>
      <div label="E-mail marketing" shortLabel="E-mail mkt" buttonClass="button-emarketing"
        :trackWithLabel="`e-mail marketing_${pageAdvertiser.name}`" class="h-100" v-if="showEmailMktTab">
        <EmailMarketingCard />
      </div>
    </Tabs>
    <div class="d-flex align-items-center justify-content-center" v-else>
      <Loader :visible="activeLoad"></Loader>
    </div>

    <div class="bottom-container" v-if="campaign">
      <NewsCard :advertiser="campaign" />
      <FilesCard :advertiser="campaign" />
    </div>

    <div id="campaign-format-history" v-if="campaign">
      <CampaignFormatHistoryCard :advertiser="campaign" />
    </div>
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Tabs from '@/components/Tabs';
import LinkFormCard from '@/components/LinkFormCard';
import EmailMarketingCard from '@/components/EmailMarketingCard';
import AdvertiserInfo from '@/components/AdvertiserInfo';
import BannerFormCard from '@/components/BannerFormCard';
import NewsCard from '@/components/cards/newsCard';
import CampaignFormatHistoryCard from '@/components/cards/CampaignFormatHistoryCard';
import FilesCard from '@/components/cards/filesCard';
import campaignTour from '@/services/tour/campaign';
import { checkMustShowTour } from '@/services/tour/tourUtils';
import Loader from '@/components/Loader';

export default {
  name: 'Campaign',
  campaign: {},
  logoUrl: undefined,
  components: {
    Tabs,
    LinkFormCard,
    BannerFormCard,
    EmailMarketingCard,
    AdvertiserInfo,
    NewsCard,
    FilesCard,
    CampaignFormatHistoryCard,
    Loader,
  },
  data() {
    return {
      activeLoad: true,
      advertiser: undefined,
    };
  },
  computed: {
    ...mapGetters([
      'allAdvertisersDetails',
      'affiliateAdvertisers',
      'pageAdvertiser',
      'enabledFeatures',
      'getCampaign',
    ]),
    showLinksTab() {
      return this.isFormatPresent(['links', 'custom_link']);
    },
    showBannersTab() {
      return this.isFormatPresent(['banners']);
    },
    showEmailMktTab() {
      return this.isFormatPresent(['email_marketing']);
    },
  },
  methods: {
    ...mapActions(['fetchAdvertiser', 'fetchAdvertisersUrlCloudfrontCreative']),
    normalizeAdvertiserNameToCode(name) {
      return name.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^A-Z0-9]+/ig, '').toLowerCase();
    },

    async loadAdvertiser(advertiserCode) {
      await this.fetchAdvertiser(advertiserCode);
      const advertiser = this.allAdvertisersDetails[advertiserCode];
      this.advertiser = advertiser;
      this.campaign = advertiser;
      this.logoUrl = advertiser.thumbnail_url;
      this.activeLoad = false;
    },
    async isApprovedTo(code) {
      const codes = this.affiliateAdvertisers.map(ad => ({
        sourceName: this.normalizeAdvertiserNameToCode(ad.desCommissionEventSourceGroup),
        idtCommissionEventSourceGroup: ad.idtCommissionEventSourceGroup,
        indStatus: ad.indStatus,
      }));
      const advertiser = codes.find(x => x.sourceName === code);
      if (!advertiser || advertiser.indStatus !== 'A') {
        window.location.href = 'https://afiliados.uol.com.br/app/campanhas';
      }
    },
    isFormatPresent(formats) {
      if (this.advertiser === undefined || this.advertiser === null) {
        return false;
      }
      return this.advertiser?.campaigns?.some(c => c.formats.some(fmt => formats.includes(fmt.id)));
    },
    showAdvertiserInfoRules() {
      this.$refs.advertiserInfo.openRulesModal();
    },
  },
  async created() {
    this.campaign = this.getCampaign;
    this.logoUrl = this.campaign ? this.campaign.url : '';
    const advertiserCode = this.$route.params.code.toString();
    await this.loadAdvertiser(advertiserCode);
    await this.fetchAdvertisersUrlCloudfrontCreative();
  },
  mounted() {
    if (checkMustShowTour('campaign')) {
      if (window.outerWidth > 600) {
        campaignTour.start();
      }
    }
  },
  watch: {
    affiliateAdvertisers: {
      immediate: true,
      handler(value) {
        if (value && value.length > 0) {
          const advertiserCode = this.$route.params.code.toString();
          this.isApprovedTo(advertiserCode);
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ {
  .button-links:before,
  .button-banners:before,
  .button-emarketing:before {
    content: "";
    width: 35px;
    height: 35px;
    display: inline-block;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    vertical-align: middle;
  }

  .button-links:before {
    background-image: url("~@/assets/images/links.svg");
  }

  .button-links.active:before {
    background-image: url("~@/assets/images/links_selected.svg");
  }

  .button-banners:before {
    background-image: url("~@/assets/images/banners.svg");
  }

  .button-banners.active:before {
    background-image: url("~@/assets/images/banners_selected.svg");
  }

  .button-emarketing:before {
    background-image: url("~@/assets/images/emarketing.svg");
  }

  .button-emarketing.active:before {
    background-image: url("~@/assets/images/emarketing_selected.svg");
  }

  .card__controls__panel {
    width: 700px;
  }

  .bottom-container {
    display: flex;
  }

  @media screen and (max-width: $lg) {
    .bottom-container {
      flex-direction: column;
    }

    .button-group-item {
      text-align: center;
      width: 33%;
    }

    .button-group-item-name {
      display: block;
    }
  }
}
</style>
